/**
 * @flow
 * @author: Vamsi Tallam
 * */

import React, { Component } from 'react'

import ApplyForFranchiseForm from './ApplyForFranchiseForm'
import {
  SectionContainer,
  HeaderSectionContainer,
  PageContentWrapper,
  PageHeading,
  PageDescription
} from './styledComponents'

class ApplyFranchiseComponent extends Component {
  render() {
    return (
      <SectionContainer>
        <HeaderSectionContainer>
          <PageContentWrapper>
            <PageHeading>iB Cricket - A Great Business Opportunity</PageHeading>
            <PageDescription>
            Businesses and individuals can partner with iB Cricket for area rights or setting up an arcade franchise
            </PageDescription>
          </PageContentWrapper>
        </HeaderSectionContainer>
        <ApplyForFranchiseForm {...this.props} />
      </SectionContainer>
    )
  }
}

export default ApplyFranchiseComponent



// WEBPACK FOOTER //
// ./src/components/ApplyFranchiseComponent/index.js